import React from 'react';
import { BsTwitter } from 'react-icons/bs';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-social">
                <a
                    target="_blank"
                    rel="noopener"
                    href="https://twitter.com/EconFinTalked"
                >
                    <BsTwitter className="footer-icon" />
                </a>
            </div>
            <br></br>
            <div className="footer-email">
                <p>Échale un grito a tu Economista en Jefe personal ;)</p>
                <a href="mailto:economiaplaticaditaysencillita@gmail.com">economiaplaticaditaysencillita@gmail.com</a>
            </div>
            <div className="footer-text">
                &copy; {new Date().getFullYear()} Economía y Finanzas Habladas
            </div>
        </footer>
    );
}

export default Footer;
